// @ts-strict-ignore
import {promisifyModal} from 'common/components/modal/utils';

import {SharingModalAttrs} from './modal/types';

export const sharingWidget = {
  promptSharing,
};

export function promptSharing(entity: Partial<SharingModalAttrs>, closeHandler = null) {
  return promisifyModal({
    tagName: `mp-sharing-modal`,
    attrs: {
      ...entity,
    },
    closeEvents: [`submit`, `close`],
    closeHandler,
  });
}
